import type { SnapshotFrom } from 'xstate'
import type { checkInMachine, CheckInContext } from './machine'

type CheckInSnapshot = SnapshotFrom<typeof checkInMachine>

/**
 * Selectors for stable reads from the check-in state machine snapshot.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const selectPatientId = checkInSelectors.patientId
 * ```
 */
export const checkInSelectors = {
  context: (snapshot: CheckInSnapshot): CheckInContext => snapshot.context,
  currentState: (snapshot: CheckInSnapshot) => snapshot.value,
  hasDiff: (snapshot: CheckInSnapshot) => snapshot.context.hasDiff,
  diffData: (snapshot: CheckInSnapshot) => snapshot.context.diffData,
  cardExpired: (snapshot: CheckInSnapshot) => snapshot.context.cardExpired,
  insurance: (snapshot: CheckInSnapshot) => snapshot.context.insurance,
  patientId: (snapshot: CheckInSnapshot) => snapshot.context.patientId,
  eebStatus: (snapshot: CheckInSnapshot) => snapshot.context.eebStatus,
  registration: (snapshot: CheckInSnapshot) => snapshot.context.registration,
  appointments: (snapshot: CheckInSnapshot) => snapshot.context.appointments,
  cardData: (snapshot: CheckInSnapshot) => snapshot.context.cardData,
  crlogId: (snapshot: CheckInSnapshot) => snapshot.context.crlogId,
  matchedPatients: (snapshot: CheckInSnapshot) => snapshot.context.matchedPatients,
  egkAttestation: (snapshot: CheckInSnapshot) => snapshot.context.egkAttestation,
  patientInfoDoneMode: (snapshot: CheckInSnapshot) => snapshot.context.patientInfoDoneMode,
}
